import React from 'react';
import { TextField } from '@mui/material';
import {Boton, Paginador} from '../comun/Index'
import Nueva from './Nueva';
import Listado from './Listado';
import axios from 'axios';
// import './estilos.css'

class Localidad extends React.Component{
  render(){
    const {nombre, seleccionar, seleccionado} = this.props;
    return(
      <span 
        className="Area"
        style={{backgroundColor: seleccionado ? '#f77838' : 'lightgrey'}}
        onClick={() => seleccionar()}
      >
        {nombre}
      </span>
    )
  }
}

const getLocalidades = function(){
  return new Promise(function(resolve, reject) {
    axios.get(localStorage.getItem('apiUrl') + '/localidades/listar/')
    .then((res) =>{
      if (res.data.status === "ok"){
        resolve(res.data.localidades)
      } else {
        reject(res.data.error)
      }
    })
    .catch((error) => reject(error))
  });
}

const getPersonas = function(params){
  return new Promise((resolve, reject) => {
    const url = localStorage.getItem('apiUrl') + '/personas/todos/';
    const config = {
      headers:{authorization:sessionStorage.getItem('token')},
      params
    };
    console.log(config)
    axios.get(url, config)
    .then((res) => resolve(res.data))
    .catch((error) => reject(error));
  })
}

export default class Mesa extends React.Component{
  constructor(props){
    super(props);
    this.state = {
      busqueda:"",
      localidades:[],
      localidadesSelec:[],
      personas:[],
      total:0,
      limit:20,
      offset:0
    }
  }

  componentDidMount(){
    getLocalidades()
    .then((localidades) => {
      this.setState({localidades});
      this.actualizar();
    })
    .catch((error) => {
      console.log(error);
      alert("Ocurrió un error");
    })
  }

  seleccionarLocalidad(localidadId){
    let localidadesSelec = JSON.parse(JSON.stringify(this.state.localidadesSelec));
    const pos = localidadesSelec.indexOf(localidadId);
    if (pos === -1){
      localidadesSelec.push(localidadId);
    } else {
      localidadesSelec.splice(pos, 1);
    }
    this.setState({localidadesSelec});
    this.actualizar(null, localidadesSelec);
  }

  setOffset(offset){
    this.setState({offset});
    this.actualizar(null, null, offset);
  }

  actualizar(busqueda = null, localidades = null, offset = null){
    const params = {
      busqueda:busqueda === null ? this.state.busqueda : busqueda,
      localidades:localidades === null ? this.state.localidades : localidades,
      offset:offset === null ? this.state.offset : offset,
      limit:this.state.limit
    }
    getPersonas(params)
    .then((resp) => this.setState({personas:resp.personas, total:resp.total}))
    .catch((error) => {
      console.log(error);
      alert("Ocurrió un error");
    })
  }

  guardado(persona_id){
    alert("Guardado");
    this.actualizar();
    this.setState({showNueva:false})
  }

  busqueda(valor){
    this.setState({busqueda:valor})
    if (valor.length > 2) this.actualizar(valor)
  }

  render(){
    const {
      busqueda,localidades,localidadesSelec,
      showNueva, total, limit, offset, personas
    } = this.state;
    return(
      <div className="Todo Configuraciones">
        {showNueva &&
          <Nueva
            localidades={localidades}
            guardado={(persona_id) => this.guardado(persona_id)}
            salir={() => this.setState({showNueva:false})}
          />
        }
        <div className="TramitesTodo">
          <h3>Personas</h3>
        </div>
        <div style={{width:'90%', display:'flex', flexDirection:'row', alignItems:'center', justifyContent:'space-between', marginBottom:10}}>
          <div className="Busqueda" >
            <TextField
              size="small"
              style={{textAlign:'center',minWidth:0,margin:'5px 1px'}}
              sx={{backgroundColor:'white', borderRadius:1}}
              label="Busqueda"
              value={busqueda}
              placeholder='DNI, apellidos, nombres...'
              onChange={(e) => this.busqueda(e.target.value)}
              variant="outlined"
            />
          </div>
          <span className='Localidades'>
            <Boton
              backgroundColor="#00A6E5"
              titulo="Nueva persona"
              size={22}
              onClick={() => this.setState({showNueva:true})}
            />
          </span>
{/*           
          <div className="Localidades">
            {localidades.map((localidad) => {
              return(
                <Localidad
                  key={localidad.id}
                  seleccionar={() => this.seleccionarLocalidad(localidad.id)}
                  seleccionado={localidadesSelec.includes(localidad.id)}
                  nombre={localidad.descripcion}
                />
              )
            })}
          </div> */}
        </div>
        <div style={{display:'flex', flexDirection:'column', width:'85%', justifyContent:'center', alignItems:'center'}}>
          {personas?.length > 0 &&
            <Listado
              personas={personas}
            />
          }
          {personas?.length > 0 &&
            <Paginador
              total={total}
              limit={limit}
              offset={offset}
              setOffset={(offset) => {window.scrollTo(0,0);this.setOffset(offset)}}
            />
          }
        </div>
      </div>
    )
  }
}